import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';

class DirectScheduleButton extends React.Component {

    render() {
        return (
            <button className="btn btn-primary"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    logUI("MBHWeb.UI.FindCareResults.DirectScheduleLinkClicked", new Date(), Tools.getURLPath());

                    let history = this.props.history;
                    let route = `/schedule/${this.props.npi}/DirectSchedule`;
                    history.push(route);
                }}
            >Schedule an Appointment</button>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        history: state.session.history,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DirectScheduleButton));
